import connect from 'utils/store/connect';

import AMPModal from './components/AMPModal';
import { changeQueryDataFilter, clearQueryData } from './duck';
import { filterSelector, isFetchingSelector, payloadSelector } from './selectors';
import {
  queryByAssetIdThunk as queryByAssetId,
  queryByWorkfrontIdThunk as queryByWorkfrontId
} from './thunks';

/**
 * map state to props
 * @param {object} state - state
 * @returns {object} props
 */
const mapStateToProps = state => ({
  data: payloadSelector(state),
  filter: filterSelector(state),
  isFetching: isFetchingSelector(state)
});

const mapDispatchToProps = {
  changeQueryDataFilter,
  clearQueryData,
  queryByAssetId,
  queryByWorkfrontId
};

export default connect(mapStateToProps, mapDispatchToProps)(AMPModal);
